// Update header height CSS variable for hero banner positioning
(function() {
  'use strict';
  
  let resizeTimeout;
  const RESIZE_DEBOUNCE_DELAY = 100;
  
  const updateHeaderHeight = () => {
    try {
      const headerWrapper = document.querySelector('.section-header-new');
      if (headerWrapper) {
        const height = headerWrapper.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${height}px`);
      }
    } catch (error) {
      console.warn('Error updating header height:', error);
    }
  };
  
  const handleResize = () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateHeaderHeight, RESIZE_DEBOUNCE_DELAY);
  };
  
  // Set header height on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderHeight);
  } else {
    updateHeaderHeight();
  }
  
  // Update on window resize with debouncing
  window.addEventListener('resize', handleResize, { passive: true });
  
  // Update after delays to ensure header is fully rendered
  setTimeout(updateHeaderHeight, 50);
  setTimeout(updateHeaderHeight, 200);
})();

